module.exports = require("npm:insert-css@2.0.0/index.js");